import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { PaginatedClusterResponseDataItemStatus } from '@/api/generated.schemas';
import { Badge, type BadgeProps } from '@/components/ui/badge';
import { Spinner } from '@/components/ui/spinner';

type Status = PaginatedClusterResponseDataItemStatus;

interface StatusBadgeProps {
  status: Status;
}

const StatusBadge: FC<StatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation();
  let variant: BadgeProps['variant'] = 'progress';
  if (status === 'completed') {
    variant = 'success';
  } else if (status === 'failed') {
    variant = 'destructive';
  }
  return (
    <Badge variant={variant}>
      {status === 'running' && (
        <Badge.Icon side={'left'}>
          <Spinner className='text-inherit' />
        </Badge.Icon>
      )}
      {t(`components.statusBadge.${status}`)}
    </Badge>
  );
};

export default StatusBadge;
